import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import * as icons from 'react-bootstrap-icons';
import PatientList from './PatientList';
import NewPatient from './NewPatient';

export default function PatTab({ reset, setTab }) {
  const [lReset, setLReset] = useState({ list: true, new: true });
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setTab(newValue);
  };

  useEffect(() => {
    if(reset) {
      setLReset({ list: true, new: true });
      setValue('1');
      setTab('1');
    }
  },[reset])

  const changeListReset = () => {
    setLReset({...lReset, list: false});
  }

  const changePatReset = () => {
    setLReset({...lReset, new: false});
  }

  return (
    <>
      {
        !reset &&
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs patient">
              <Tab label={<span><icons.PersonLinesFill size={20} className='ms-2'/>{'لیست بیماران'}</span>} value="1" />
              <Tab label={<span><icons.PersonPlusFill size={20} className='ms-2'/>{'بیمار جدید'}</span>} value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <PatientList
              reset={lReset.list}
              doReset={changeListReset}
            />
          </TabPanel>
          <TabPanel value="2">
            <NewPatient
              reset={lReset.new}
              doReset={changePatReset}
            />
          </TabPanel>
        </TabContext>
      }
    </>
  );
}